module.exports = __webpack_public_path__ + "img/akumulacioni-tank.06437454.png";